import axiosV2Instance from './axiosV2Instance';

export interface HabiHabit {
  id: number;
  userId: number;
  title: string;
  isDaily: boolean;
  scheduledDate?: string | null;
  sortOrder: number;
  createdAt: string;
  isCompleted: boolean;
}

export interface HabiHabitsForDateResponse {
  habits: HabiHabit[];
  date: string;
}

export interface CreateHabiHabitRequest {
  title: string;
  isDaily?: boolean;
  scheduledDate?: string | null;
}

export interface UpdateHabiHabitRequest {
  title: string;
  isDaily: boolean;
  scheduledDate?: string | null;
  sortOrder: number;
}

class HabiApi {
  private baseUrl = '/habi';

  async getHabitsForDate(date?: string): Promise<HabiHabitsForDateResponse> {
    const params = date ? { date } : {};
    const response = await axiosV2Instance.get<HabiHabitsForDateResponse>(
      `${this.baseUrl}/habits`,
      { params }
    );
    return response.data;
  }

  async createHabit(request: CreateHabiHabitRequest): Promise<HabiHabit> {
    const response = await axiosV2Instance.post<HabiHabit>(
      `${this.baseUrl}/habits`,
      { ...request, isDaily: request.isDaily ?? true }
    );
    return response.data;
  }

  async getHabitById(habitId: number): Promise<HabiHabit> {
    const response = await axiosV2Instance.get<HabiHabit>(
      `${this.baseUrl}/habits/${habitId}`
    );
    return response.data;
  }

  async updateHabit(habitId: number, request: UpdateHabiHabitRequest): Promise<HabiHabit> {
    const response = await axiosV2Instance.put<HabiHabit>(
      `${this.baseUrl}/habits/${habitId}`,
      request
    );
    return response.data;
  }

  async deleteHabit(habitId: number): Promise<void> {
    await axiosV2Instance.delete(`${this.baseUrl}/habits/${habitId}`);
  }

  async toggleCompletion(habitId: number, date?: string): Promise<{ isCompleted: boolean }> {
    const params = date ? { date } : {};
    const response = await axiosV2Instance.post<{ isCompleted: boolean }>(
      `${this.baseUrl}/habits/${habitId}/toggle`,
      null,
      { params }
    );
    return response.data;
  }
}

export const habiApi = new HabiApi();
